import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TalentDeclaration({accept,setAccept}) {
    const navigate = useNavigate();
    

    return (
        <div class="max-w-4xl mx-auto">

            <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">

                <div class="border-b border-slate-200 p-6 text-center bg-white">
                    <h1 class="text-2xl sm:text-3xl font-extrabold text-slate-900">
                        Talent / User Consent & Declaration
                    </h1>
                </div>

                <div class="p-6 sm:p-8 max-h-[580px] overflow-y-auto space-y-6">

                    <p class="text-slate-700 text-sm sm:text-base leading-relaxed">
                        FilmWings is a professional platform where talent can create a portfolio and be discovered by verified clients for genuine opportunities. This page explains what you agree to when you create an account, upload content, and respond to bookings.
                    </p>

                    <p class="text-slate-700 text-sm sm:text-base leading-relaxed">
                        We request all users to always check credentials of the requites/artists and verify the same independently before deciding to work with them. You should never transfer any money to anyone claiming to be representing FilmWIngs and demanding money for Artist Card, Audition Fee, Travel etc.
                    </p>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            What you confirm (Talent Declaration)
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            By signing up and using FilmWings, you confirm that:
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500 mb-3">
                            <li>Your profile details are true and not misleading. This includes your name, age, location, skills, experience, work history, availability, and any other information you add.</li>
                            <li>You will maintain only one account. Duplicate profiles, impersonation, or fake credentials are not allowed.</li>
                            <li>You will keep your profile updated. If key details change, you will update them within a reasonable time.</li>
                        </ul>
                        <p class="text-slate-700 text-sm sm:text-base">
                            FilmWings may request verification checks to keep the platform safe and credible. Your profile visibility may be limited until verification is complete.
                        </p>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Social media links & external portfolios (explicit consent)
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            By adding Instagram/YouTube/portfolio links to your profile, you are choosing to share them for professional evaluation. FilmWings will display these links to support clients' discovery and shortlisting.
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>You confirm you own/control the linked accounts, or have authorization to share them.</li>
                            <li>You consent to FilmWings displaying these links on your profile and sharing them with verified clients for evaluation.</li>
                            <li>FilmWings is not responsible for content on third-party platforms, but may restrict links that appear unsafe, misleading, or unrelated.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Talent accuracy + misrepresentation rule
                        </h2>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>You agree not to display wrong measurements, fake credits, fake brand collaborations, or edited identity details that could mislead a client's decision.</li>
                            <li>Repeated misrepresentation may result in a restricted or removed profile.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            What you allow FilmWings to do (Limited permission)
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            To operate the platform, you enable FilmWings to:
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500 mb-3">
                            <li>Host and display your profile content on FilmWings (app and website) in a professional listing format.</li>
                            <li>Share your profile with relevant, verified clients to support shortlisting and booking decisions.</li>
                            <li>Use your profile content only for platform functioning (like matching, discovery, and showing your portfolio to clients).</li>
                        </ul>
                        <p class="text-slate-700 text-sm sm:text-base">
                            This is a limited, non-exclusive, revocable permission. Your portfolio remains yours; FilmWings does not claim ownership of your photos/videos.
                        </p>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Protection against misuse (Important)
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            FilmWings informs clients that portfolio content is for evaluation only. However, you acknowledge that screenshots or misuse can still happen outside the platform. If you report misuse, FilmWings may take reasonable steps, such as issuing warnings, suspending accounts, and providing assistance with logs/evidence trails where available.
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>Clients are not allowed to publish your portfolio content (ads, posters, social media, casting announcements) unless they have your separate written permission.</li>
                            <li>If misuse is reported, FilmWings may restrict the client’s access and talents can block the client Profile conduct an investigation.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Booking, payment, and professionalism
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            Each project will have its own brief and terms. By using FilmWings, you agree that:
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>You will communicate professionally with clients and FilmWings support (in-app, Chart).</li>
                            <li>You will not misrepresent availability, commitments, or deliverables.</li>
                            <li>Payment terms will be as per the booking confirmation. Payment may be via client flow or direct client payment, depending on the job details.</li>
                            <li>Filmwings will not responding the payments.</li>
                            <li>You will not demand/accept payments through misleading routes connected to platform interactions.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Safety and boundaries
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            FilmWings expects safe and respectful interactions.
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>You can refuse any assignment that feels unsafe, illegal, exploitative, or inappropriate.</li>
                            <li>Report suspicious behavior immediately (e.g., harassment, coercion, scams, or unsafe requests).</li>
                            <li>No harassment or abuse towards any user on the platform.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 class="font-bold text-slate-900 text-base sm:text-lg mb-3">
                            Enforcement
                        </h2>
                        <p class="text-slate-700 text-sm sm:text-base mb-3">
                            To protect users and clients, FilmWings may restrict or remove accounts if:
                        </p>
                        <ul class="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                            <li>Profile information is false/misleading,</li>
                            <li>Duplicate profiles or impersonation are detected,</li>
                            <li>Misuse/harassment is reported,</li>
                            <li>Platform rules are repeatedly violated.</li>
                        </ul>
                    </div>

                    <div className="p-6 bg-white border-t border-slate-200">
                            {/* Checkbox Area */}
                            <div className="p-4 bg-slate-50 rounded-xl border border-slate-200 mb-6">
                                <label className="flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={accept}
                                        onChange={(e) => setAccept(e.target.checked)}
                                        className="w-5 h-5 text-blue-600 rounded border-slate-300 focus:ring-blue-500 accent-blue-600 cursor-pointer flex-shrink-0"
                                    />
                                    <span className="text-slate-800 text-xs sm:text-sm font-semibold select-none">
                                        I confirm my details are accurate, and I agree to the Talent Consent & Declaration,{" "}
                                        <a
                                            href="https://filmwings.com/index.php/terms_service"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="text-blue-600 hover:text-blue-700 underline hover:no-underline"
                                        >
                                            Terms
                                        </a>{" "}
                                        and{" "}
                                        <a
                                            href="https://filmwings.com/index.php/privacy_policy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="text-blue-600 hover:text-blue-700 underline hover:no-underline"
                                        >
                                            Privacy Policy
                                        </a>
                                        
                                    </span>
                                </label>
                            </div>
                        </div>

                </div>
            </div>
        </div>
    );
}